import { HttpClient, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, catchError, finalize, switchMap, throwError } from "rxjs";
import { apiBaseUrlGetter } from "./appInitializer";
import { tokenSetter } from "./jwtUtls";

@Injectable()
export class JWTAuthInterceptor implements HttpInterceptor {

  private baseUrl = apiBaseUrlGetter();
  private tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>("");

  constructor(
    private http: HttpClient,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err, caught) => {
        if (request.url == this.baseUrl + "/auth/token") {
          return throwError(() => err);
        }
        else {
          if (err instanceof HttpErrorResponse && err.status === 401) {
            return this.handle401Error(request, next);
          }
          else {
            return throwError(() => err);
          }
        }
      }),
      finalize(() => {

      })
    );
  }
  
  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    return this.httpGetToken().pipe(
      switchMap((access_token) => {
        this.tokenSubject.next(access_token);
        tokenSetter(access_token);
        return next.handle(this.addToken(request, access_token));
      })
    );
  }
  
  private httpGetToken() {
    return this.http.get<string>(this.baseUrl + "/auth/token");
  }
  
  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        'Authorization': `Bearer ${token}`
      }
    });
  }

}
